function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#FFF",
  d: "M248.703 161.533h-7.438l-.263-11.632-11.37 11.632h-31.53v31.86h30.923l11.713 11.713v-11.713h7.965z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M188.72 185.74H171.1l-10.538-10.538v10.538h-7.774v31.86h7.965v11.713l11.713-11.713h30.923v-31.714zm66.32-159.037c0 1.384 1.749 2.506 3.907 2.506 2.157 0 3.906-1.122 3.906-2.506 0-1.384-1.75-2.506-3.906-2.506-2.158 0-3.907 1.122-3.907 2.506"
}), React.createElement("path", {
  d: "M255.805 27.141c0 1.384 1.75 2.506 3.907 2.506 2.158 0 3.907-1.122 3.907-2.506 0-1.384-1.749-2.506-3.907-2.506-2.157 0-3.907 1.122-3.907 2.506z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M255.805 27.141v2.317c0 1.384 1.75 2.506 3.907 2.506 2.158 0 3.907-1.122 3.907-2.506v-2.317",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M272.09 48.831l-26.366-20.075 25.329-19.285 26.368 20.075zm25.33 10.621l-25.33 19.285-26.366-20.075m-.001-29.906v9.687m51.697 57.74v9.203m-51.697-9.994v9.687m26.367-56.248v9.978"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M297.42 68.471l-25.33 19.285-26.366-20.075m51.696-8.897v9.687m-51.697-30.696v29.906M272.09 78.07v9.977"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M297.42 49.929l-25.33 19.285-26.366-20.075m51.696.122v9.687m-25.33 9.598v9.977"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M297.42 40.406L272.09 59.69l-26.366-20.076m51.696-10.067v19.878m-25.33 9.598V69m25.33 8.49l-25.33 19.285L245.725 76.7m51.695-8.897v9.687m-51.697-10.477V76.7m26.367 10.389v9.977"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M297.42 86.51l-25.33 19.284-26.366-20.075m51.696-8.896v9.687m-51.697-10.478v9.688m26.367 10.388v9.977"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M297.42 96.21l-25.33 19.284-26.366-20.075m51.696-8.897v9.687m-51.697-10.477v9.688m26.367 10.387v9.977m0 8.729l-26.366-20.075m26.366 10.388v9.978m0 8.728l-26.366-20.075m-.001-9.687v9.688m26.367 10.388v9.977m0 8.729l-26.366-20.075m-.001-9.687v9.686m26.367 10.388v9.978"
}), React.createElement("path", {
  d: "M293.227 112.734c0 1.438 1.817 2.604 4.061 2.604 2.242 0 4.06-1.166 4.06-2.604 0-1.438-1.818-2.604-4.06-2.604-2.244 0-4.06 1.166-4.06 2.604",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M294.023 113.19c0 1.437 1.818 2.603 4.061 2.603 2.242 0 4.06-1.166 4.06-2.604 0-1.438-1.818-2.604-4.06-2.604-2.243 0-4.06 1.166-4.06 2.604z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M294.023 113.19v2.407c0 1.44 1.818 2.605 4.061 2.605 2.242 0 4.06-1.166 4.06-2.605v-2.408",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M298.393 143.341l-26.367-18.802 25.33-19.284 26.366 18.801z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M323.722 133.743l-25.329 19.285-26.367-20.075m26.367 10.388v9.977"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M323.722 143.102l-25.329 19.285-26.367-20.075m26.367 10.388v9.977m25.487-74.13l-26.367-20.076 25.329-19.284 26.367 20.075z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M349.209 77.957l-25.33 19.737-26.366-20.075M349 69v55.494m-25.12-35.947v7.101"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M349.209 86.511l-25.33 19.738-26.366-19.74M323.88 95.2v9.978"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M349.209 95.132l-25.33 20.646-26.366-19.595m26.367 8.547v9.977m25.329-10.046l-25.33 19.285m.001-9.687v9.978m25.329-10.047l-25.33 19.286m.001-9.687v9.977m25.329-10.046l-25.33 19.286m.001-9.688v9.978m-157.868 53.34h20.607m-20.607 5.622h29.518m-29.518 5.622h29.518m38.887-29.829h-29.518m29.518-5.963h-29.518m29.518 11.585h-29.518"
}), React.createElement("path", {
  d: "M56.832 274.104c0 1.438 1.817 2.604 4.06 2.604 2.243 0 4.06-1.166 4.06-2.604 0-1.438-1.817-2.604-4.06-2.604-2.243 0-4.06 1.166-4.06 2.604",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M57.628 274.559c0 1.438 1.818 2.604 4.06 2.604 2.244 0 4.06-1.166 4.06-2.604 0-1.438-1.816-2.604-4.06-2.604-2.242 0-4.06 1.166-4.06 2.604z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M57.628 274.559v2.409c0 1.438 1.818 2.604 4.06 2.604 2.244 0 4.06-1.166 4.06-2.604v-2.41",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M63.998 305.46L37.63 285.387 62.96 266.1l26.368 20.075z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M89.328 295.863l-25.33 19.285-26.367-20.076m51.697-8.897v9.688M37.63 285.385v9.688m51.698.745v9.203m-25.33.439v9.979"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M89.328 304.882l-25.33 19.285-26.367-20.076m51.697-8.896v9.688M37.63 294.404v9.688m26.368 10.388v9.978m25.33-57.019v9.687m0-.668v9.687m0 .013v9.688m-25.33 28.303L37.63 304.074m26.368 29.094L37.63 313.093m0-9.687v9.686m26.368 10.388v9.979m0 8.728L37.63 322.112m0-9.687v9.687M63.998 332.5v9.978"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M89.263 304.89l26.366 18.8L90.3 342.977l-26.367-18.801"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M115.63 333.378L90.3 352.663l-26.367-20.075M90.3 342.976v9.977"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M115.63 342.738L90.3 362.022l-26.367-20.075M90.3 352.336v9.977"
}), React.createElement("path", {
  d: "M110.492 256.502c0 1.438 1.818 2.604 4.061 2.604s4.06-1.166 4.06-2.604c0-1.438-1.817-2.604-4.06-2.604-2.243 0-4.061 1.166-4.061 2.604",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M111.289 256.956c0 1.438 1.817 2.604 4.06 2.604 2.243 0 4.06-1.166 4.06-2.604 0-1.438-1.817-2.604-4.06-2.604-2.243 0-4.06 1.166-4.06 2.604z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M111.289 256.956v2.41c0 1.437 1.817 2.603 4.06 2.603 2.243 0 4.06-1.166 4.06-2.604v-2.409",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M115.787 288.182L89.42 268.106l25.329-19.284 26.367 20.075z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M141.116 277.592l-25.329 19.737-26.367-20.075m51.696-8.357v6.811m-25.329 12.474v7.101"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M141.116 286.147l-25.329 19.737-26.367-19.74m51.696-10.594v10.597m-25.329 8.688v9.978"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M141.116 294.767l-25.329 20.646-26.367-19.595m51.696-10.738v9.687m-25.329 9.598v9.977m25.329-10.045l-25.329 19.285m25.329-28.972v9.687m-25.329 9.597v9.978m25.329-10.046l-25.329 19.285m25.329-28.972v9.687m-25.329 9.598v9.977m25.329-10.045l-25.329 19.285m25.329-28.972v9.687m-25.329 9.597v9.978m192.176-70.818l-26.367-20.075 25.329-19.285 26.367 20.076z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M333.292 262.516l-25.33 19.285-26.366-20.076m51.696-8.897v9.688m-51.696-10.478v9.687m26.367 10.388v9.978"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M333.292 271.535l-25.33 19.285-26.366-20.076m51.696-8.897v9.688m-51.696-10.478v9.687m26.367 10.389v9.978"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M333.292 280.554l-25.33 19.285-26.366-20.076m51.696-8.897v9.689m-51.696-10.479v9.687m26.367 10.389v9.978"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M333.292 289.573l-25.33 19.285-26.366-20.076m51.696-8.897v9.689m-51.696-10.478v9.687m26.367 10.387v9.979"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M333.292 299.273l-25.33 19.285-26.366-20.076m51.696-8.897v9.688m-51.696-10.478v9.687m26.367 10.388v9.978"
}), React.createElement("path", {
  d: "M261.868 268.778c0 1.438 1.818 2.604 4.06 2.604 2.243 0 4.06-1.166 4.06-2.604 0-1.438-1.817-2.604-4.06-2.604-2.242 0-4.06 1.166-4.06 2.604",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M262.664 269.233c0 1.438 1.818 2.604 4.06 2.604 2.244 0 4.06-1.166 4.06-2.604 0-1.438-1.816-2.604-4.06-2.604-2.242 0-4.06 1.166-4.06 2.604z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M262.664 269.233v2.408c0 1.44 1.818 2.605 4.06 2.605 2.244 0 4.06-1.166 4.06-2.605v-2.408",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M250.92 259.93c0 1.437 1.818 2.603 4.062 2.603 2.242 0 4.06-1.166 4.06-2.604 0-1.438-1.818-2.604-4.06-2.604-2.244 0-4.061 1.166-4.061 2.604",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M251.717 260.385c0 1.438 1.818 2.603 4.06 2.603 2.243 0 4.06-1.166 4.06-2.603 0-1.438-1.817-2.604-4.06-2.604-2.242 0-4.06 1.166-4.06 2.603z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M251.717 260.385v2.408c0 1.438 1.818 2.604 4.06 2.604 2.243 0 4.06-1.166 4.06-2.604v-2.409",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M256.215 291.61l-26.367-20.075 25.329-19.285 26.367 20.075z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M281.544 281.02l-25.33 19.737-26.366-20.075m51.696-8.357v6.81m-25.329 12.475v7.101"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M281.544 289.575l-25.33 19.737-26.366-19.738m51.696-10.596v10.596m-25.329 8.689v9.978m25.329-19.733v9.687m-25.329 9.598v9.978"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M229.847 271.535v27.71l26.367 19.596 25.33-20.646M98.728 117.086L72.361 97.01l25.33-17.4 26.367 19.73z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M149.669 88.695l-50.94 38.078-26.368-20.075m0-9.688v9.688m26.367 10.388v9.978"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M124.058 116.507l-25.33 19.285-26.367-20.076m0-9.686v9.686m26.367 10.389v9.978"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M124.058 125.526l-25.33 19.285-26.367-20.076m0-9.686v9.687m26.367 10.388v9.978"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M124.058 134.545l-25.33 19.285-26.367-20.076m26.367 10.389v9.978"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M124.058 144.245l-25.33 19.285-26.367-20.076m0-9.687v9.687m26.367 10.389v9.688"
}), React.createElement("path", {
  d: "M143.845 114.255c0 1.438 1.817 2.604 4.06 2.604 2.243 0 4.06-1.166 4.06-2.604 0-1.438-1.817-2.604-4.06-2.604-2.243 0-4.06 1.166-4.06 2.604",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M144.64 114.71c0 1.438 1.818 2.604 4.061 2.604s4.06-1.166 4.06-2.604c0-1.438-1.817-2.604-4.06-2.604-2.243 0-4.06 1.166-4.06 2.604z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M144.64 114.71v2.408c0 1.439 1.818 2.605 4.061 2.605s4.06-1.166 4.06-2.605v-2.408",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M84.873 95.208c0 1.438 1.817 2.604 4.06 2.604 2.243 0 4.06-1.166 4.06-2.604 0-1.438-1.817-2.604-4.06-2.604-2.243 0-4.06 1.166-4.06 2.604",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M85.669 95.663c0 1.438 1.818 2.604 4.06 2.604 2.244 0 4.06-1.166 4.06-2.604 0-1.438-1.816-2.604-4.06-2.604-2.242 0-4.06 1.166-4.06 2.604z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M85.669 95.663v2.408c0 1.439 1.818 2.605 4.06 2.605 2.244 0 4.06-1.166 4.06-2.605v-2.408",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M101.492 96.249c0 1.438 1.818 2.604 4.061 2.604s4.061-1.166 4.061-2.604c0-1.438-1.818-2.604-4.061-2.604s-4.061 1.166-4.061 2.604",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M102.289 96.704c0 1.438 1.817 2.604 4.06 2.604 2.243 0 4.06-1.166 4.06-2.604 0-1.438-1.817-2.604-4.06-2.604-2.243 0-4.06 1.166-4.06 2.604z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M102.289 96.704v2.408c0 1.439 1.817 2.605 4.06 2.605 2.243 0 4.06-1.166 4.06-2.605v-2.408m40.108 39.878l-26.367-20.075 25.33-19.285 26.366 20.075z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M175.846 125.992l-25.328 19.737-26.368-20.075m51.696-8.356v6.81m-25.329 12.474v7.101"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M175.846 134.547l-25.328 19.737-26.368-19.739m51.696-10.595v10.597m-25.329 8.688v9.978"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M175.846 143.167l-25.328 20.646-26.368-19.595m51.696-10.738v9.688m-25.329 9.597v10.67m-.75-92.143l-25.33 19.285-26.635-20.075m51.965 9.485l-25.33 19.737m25.33-28.432v6.81m0-.157v10.596m-25.33 2.036l-.262 53.89m25.592-56.993v9.688m-129.225 19.59v9.009m0-.668v9.687m0 .012v9.687"
}), React.createElement("path", {
  d: "M51.497 114.489c0 1.438 1.818 2.604 4.06 2.604 2.244 0 4.06-1.166 4.06-2.604 0-1.438-1.816-2.604-4.06-2.604-2.242 0-4.06 1.166-4.06 2.604",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M52.294 114.944c0 1.438 1.817 2.604 4.06 2.604 2.243 0 4.06-1.166 4.06-2.604 0-1.438-1.817-2.604-4.06-2.604-2.243 0-4.06 1.166-4.06 2.604z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M52.294 114.944v2.41c0 1.437 1.817 2.603 4.06 2.603 2.243 0 4.06-1.166 4.06-2.604v-2.409",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M30.4 114.66c0 1.438 1.817 2.604 4.06 2.604 2.242 0 4.06-1.166 4.06-2.604 0-1.438-1.818-2.604-4.06-2.604-2.243 0-4.06 1.166-4.06 2.604",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M31.195 115.115c0 1.438 1.818 2.604 4.061 2.604s4.06-1.166 4.06-2.604c0-1.438-1.817-2.604-4.06-2.604-2.243 0-4.06 1.166-4.06 2.604z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M31.195 115.115v2.408c0 1.439 1.818 2.605 4.061 2.605s4.06-1.166 4.06-2.605v-2.408",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M41.73 123.28c0 1.438 1.817 2.604 4.06 2.604 2.243 0 4.06-1.166 4.06-2.604 0-1.438-1.817-2.604-4.06-2.604-2.243 0-4.06 1.166-4.06 2.604",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M42.526 123.735c0 1.438 1.817 2.604 4.061 2.604 2.242 0 4.06-1.166 4.06-2.604 0-1.438-1.818-2.604-4.06-2.604-2.244 0-4.06 1.166-4.06 2.604z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M42.526 123.735v2.408c0 1.44 1.817 2.605 4.061 2.605 2.242 0 4.06-1.166 4.06-2.605v-2.408",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M42.12 106.968c0 1.438 1.818 2.604 4.06 2.604 2.244 0 4.06-1.166 4.06-2.604 0-1.438-1.816-2.605-4.06-2.605-2.242 0-4.06 1.167-4.06 2.605",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M42.917 107.423c0 1.438 1.817 2.604 4.06 2.604 2.243 0 4.06-1.166 4.06-2.604 0-1.438-1.817-2.605-4.06-2.605-2.243 0-4.06 1.167-4.06 2.605z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M42.917 107.423v2.408c0 1.44 1.817 2.605 4.06 2.605 2.243 0 4.06-1.166 4.06-2.605v-2.408",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M47 135.383l-26.366-18.642 25.329-19.284L72.33 115.97z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M72.33 126.227L47 145.964l-26.366-20.075"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M72.33 134.781L47 154.518 20.635 134.78m51.695-10.595v10.597m-25.33.601v18.064"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M72.33 143.402L47 164.048l-26.366-19.595m51.696-10.738v9.687M47 153v9.977m50.69-92.475v9.109"
}), React.createElement("path", {
  d: "M117.765 59.654c0 1.438 1.817 2.603 4.061 2.603 2.242 0 4.06-1.165 4.06-2.603 0-1.439-1.818-2.605-4.06-2.605-2.244 0-4.06 1.166-4.06 2.605",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M118.561 60.109c0 1.438 1.818 2.604 4.061 2.604 2.242 0 4.06-1.166 4.06-2.604 0-1.438-1.818-2.604-4.06-2.604-2.243 0-4.06 1.166-4.06 2.604z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M118.561 60.109v2.409c0 1.438 1.818 2.604 4.061 2.604 2.242 0 4.06-1.166 4.06-2.604v-2.41",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M124.437 81.981L97.802 61.906 123.4 42.621l26.368 20.075zm25.33-19.284v6.81m0-.157v10.596m-25.33 2.035l-.262 53.891M97.69 61.906v9.109m147.972 90.518h-7.44l-.262-11.632-11.37 11.632h-31.53v31.86h30.923l11.713 11.713v-11.713h7.966z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M190.7 185.74h-17.622l-10.538-10.538v10.538h-7.773v31.86h7.965v11.713l11.713-11.713h30.923v-19.54"
}), React.createElement("path", {
  d: "M74.158 280.23s-5.078 3.668-4.894 3.668l5.674 4.305-.78-7.973z",
  fill: "#DFC0FF"
}), React.createElement("path", {
  d: "M75.423 280.741s-5.078 3.668-4.894 3.668l5.674 4.305-.78-7.973z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M76.203 288.714v2.414l-5.674-4.305v-2.414 1.72"
}), React.createElement("path", {
  d: "M102.992 261.814s-5.079 3.668-4.895 3.668l5.675 4.305-.78-7.973z",
  fill: "#DFC0FF"
}), React.createElement("path", {
  d: "M104.257 262.325s-5.08 3.668-4.895 3.668l5.675 4.305-.78-7.974z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M105.037 270.298v2.414l-5.675-4.305v-2.414 1.718"
}), React.createElement("path", {
  d: "M254.992 273.564s-5.079 3.668-4.895 3.668l5.675 4.305-.78-7.973z",
  fill: "#DFC0FF"
}), React.createElement("path", {
  d: "M256.257 274.075s-5.08 3.668-4.895 3.668l5.675 4.305-.78-7.974z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M257.037 282.048v2.414l-5.675-4.305v-2.414 1.718"
}), React.createElement("path", {
  d: "M295.242 247.064s-5.08 3.668-4.895 3.668l5.675 4.305-.78-7.973z",
  fill: "#DFC0FF"
}), React.createElement("path", {
  d: "M296.507 247.575s-5.08 3.668-4.895 3.668l5.675 4.305-.78-7.974z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M297.287 255.548v2.414l-5.675-4.305v-2.414 1.718"
}), React.createElement("path", {
  d: "M306.242 255.564s-5.08 3.668-4.895 3.668l5.675 4.305-.78-7.973z",
  fill: "#DFC0FF"
}), React.createElement("path", {
  d: "M307.507 256.075s-5.08 3.668-4.895 3.668l5.675 4.305-.78-7.974z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M308.287 264.048v2.414l-5.675-4.305v-2.414 1.718"
}), React.createElement("path", {
  d: "M269.992 32.064s-5.079 3.668-4.895 3.668l5.675 4.305-.78-7.973z",
  fill: "#DFC0FF"
}), React.createElement("path", {
  d: "M271.257 32.574s-5.08 3.668-4.895 3.668l5.675 4.305-.78-7.973z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M272.037 40.548v2.414l-5.675-4.305v-2.414 1.718"
}), React.createElement("path", {
  d: "M77.158 318.397s-5.078 3.668-4.894 3.668l5.674 4.305-.78-7.973z",
  fill: "#DFC0FF"
}), React.createElement("path", {
  d: "M78.423 318.908s-5.078 3.668-4.894 3.668l5.674 4.305-.78-7.973z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M79.203 326.88v2.415l-5.674-4.305v-2.414 1.719"
}), React.createElement("path", {
  d: "M100.242 317.814s-5.079 3.668-4.895 3.668l5.675 4.305-.78-7.973z",
  fill: "#DFC0FF"
}), React.createElement("path", {
  d: "M101.507 318.325s-5.08 3.668-4.895 3.668l5.675 4.305-.78-7.974z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M102.287 326.298v2.414l-5.675-4.305v-2.414 1.718"
}), React.createElement("path", {
  fill: "#EBFFC0",
  d: "M43.394 283.399l4.908 3.804 5.866-4.294-4.899-3.846z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M45.342 283.399l4.908 3.804 5.866-4.294-4.9-3.846zm10.913-.455l.008 3.138c-.035.015-5.937 4.31-5.937 4.31"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M45.209 283.346v3.063l5.04 3.855v-3.087"
}), React.createElement("path", {
  fill: "#EBFFC0",
  d: "M81.311 313.649l4.908 3.804 5.866-4.294-4.9-3.846z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M83.342 313.649l4.908 3.804 5.866-4.294-4.9-3.846zm10.913-.455l.008 3.138c-.035.015-5.937 4.31-5.937 4.31"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M83.209 313.596v3.063l5.04 3.855v-3.087"
}), React.createElement("path", {
  fill: "#EBFFC0",
  d: "M120.061 267.565l4.908 3.804 5.866-4.294-4.9-3.845z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M122.342 267.565l4.908 3.804 5.866-4.294-4.9-3.845zm10.913-.455l.008 3.138c-.035.015-5.937 4.311-5.937 4.311"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M122.209 267.513v3.062l5.04 3.856v-3.087"
}), React.createElement("path", {
  fill: "#EBFFC0",
  d: "M108.394 275.899l4.908 3.804 5.866-4.294-4.899-3.846z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M110.675 275.899l4.908 3.804 5.867-4.294-4.9-3.846zm10.913-.455l.008 3.138c-.034.015-5.937 4.31-5.937 4.31"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M110.543 275.846v3.063l5.04 3.855v-3.087"
}), React.createElement("path", {
  fill: "#EBFFC0",
  d: "M316.727 56.315l4.908 3.804 5.867-4.294-4.9-3.845z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M317.675 56.315l4.908 3.804 5.867-4.294-4.9-3.845zm10.913-.455l.008 3.138c-.034.015-5.937 4.311-5.937 4.311"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M317.543 56.263v3.062l5.04 3.856v-3.087"
}), React.createElement("path", {
  fill: "#EBFFC0",
  d: "M329.061 66.649l4.908 3.804 5.866-4.294-4.9-3.846z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M330.009 66.649l4.907 3.804 5.867-4.294-4.9-3.846zm10.913-.455l.007 3.138c-.034.015-5.937 4.31-5.937 4.31"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M329.876 66.596v3.063l5.04 3.855v-3.087"
}), React.createElement("path", {
  fill: "#EBFFC0",
  d: "M279.477 122.065l4.908 3.804 5.867-4.294-4.9-3.845z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M280.425 122.065l4.908 3.804 5.867-4.294-4.9-3.845zm10.913-.455l.008 3.138c-.034.015-5.937 4.311-5.937 4.311"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M280.293 122.013v3.062l5.04 3.856v-3.087"
}), React.createElement("path", {
  fill: "#EBFFC0",
  d: "M291.811 132.399l4.908 3.804 5.866-4.294-4.9-3.846z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M292.759 132.399l4.907 3.804 5.867-4.294-4.9-3.846zm10.913-.455l.007 3.138c-.034.015-5.937 4.31-5.937 4.31"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M292.626 132.346v3.063l5.04 3.855v-3.087"
}), React.createElement("path", {
  fill: "#FFC5C5",
  d: "M307.696 69.35l-.496-3.61 4.107-2.126 5.311 1.417.425 3.328-3.753 2.772z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M308.522 69.54l-.212-3.613 3.823-2.124 5.311 1.416.425 3.328-3.753 2.921z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M317.87 68.5v2.738l-3.684 2.921-5.593-1.93-.071-2.69m5.594 1.929l.07 2.691"
}), React.createElement("path", {
  fill: "#FFC5C5",
  d: "M301.967 243.767l-.496-3.611 4.107-2.125 5.31 1.417.426 3.328-3.753 2.773z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M302.793 243.956l-.212-3.611 3.823-2.125 5.31 1.417.426 3.328-3.753 2.92z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M312.14 242.917v2.738l-3.683 2.92-5.594-1.928-.07-2.691m5.594 1.929l.07 2.69"
}), React.createElement("path", {
  fill: "#FFC5C5",
  d: "M266.362 21.35l-.495-3.61 4.106-2.126 5.312 1.417.425 3.328-3.753 2.772z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M267.188 21.54l-.21-3.613 3.821-2.124 5.312 1.416.425 3.328-3.753 2.921z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M276.537 20.5v2.738l-3.684 2.921-5.593-1.93-.072-2.69m5.595 1.929l.07 2.691"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 370 370",
    width: "1em",
    height: "1em"
  }, props), _ref);
};

export default SvgComponent;


// WEBPACK FOOTER //
// ./src/components/sections/ourVirtualExperts/steps/slides/slide_5.svg